module.exports = __webpack_public_path__ + "static/media/background.274d33de.png";